module.exports = __webpack_public_path__ + "static/media/Signet.72397b87.svg";